import * as React from 'react';

import S12nSubscriptionVPropBulletPoints from 'bundles/enroll-modal/components/s12n-subscriptions/S12nSubscriptionVPropBulletPoints';
import S12nSubscriptionVPropCDP from 'bundles/enroll-modal/components/s12n-subscriptions/S12nSubscriptionVPropCDP';
import S12nSubscriptionVPropSDP from 'bundles/enroll-modal/components/s12n-subscriptions/S12nSubscriptionVPropSDP';

import 'css!./__styles__/SubscriptionVProp';

type PropsFromCaller = {
  onSdp: boolean;
};

const S12nSubscriptionVProp = ({ onSdp }: PropsFromCaller) => {
  return (
    <div className="rc-SubscriptionVProp">
      <div className="punch-line">{onSdp ? <S12nSubscriptionVPropSDP /> : <S12nSubscriptionVPropCDP />}</div>
      <S12nSubscriptionVPropBulletPoints />
    </div>
  );
};

export default S12nSubscriptionVProp;
